"use client";

import React from 'react';
import { Box, Container } from '@mui/material';
import dynamic from 'next/dynamic';

interface PublicPageLayoutProps {
  children: React.ReactNode;
}

export const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({ children }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh', // Ensure layout takes full viewport height
      width: '100%',
      overflowX: 'hidden', // Prevent horizontal scroll
    }}>
      {/* Header is provided globally by ClientProviders to avoid duplicates */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      {/* Footer is rendered globally by ClientProviders (ClientFooter) to ensure a single footer at page bottom */}
    </Box>
  );
};
